import * as variables from './variables.js';
import * as $ from 'jquery';
import Debouncer from './lib/Debouncer';

import 'es6-promise/auto';
import 'whatwg-fetch';

import {Analytics} from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import './component/menu.service';

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

// BACKLOG: Move SearchForm out of MainMenu
import SearchForm from './component/MainMenu/SearchForm';
new SearchForm('.searchArea', '.searchArea__icon', '.searchArea__query', 'open');

import Forms from './component/Forms';
Forms.init();

import AutoLoadPages from './lib/AutoLoadItems';

const autoLoadOpsArr = [{
	frameId: 'caseStudyList',
	nextClass: 'btn--next',
	resultsClass: 'caseStudyListItem',
	paginationClass: 'pagination'
}];
let autoLoaders: AutoLoadPages[] = [];
for (let i = 0; i < autoLoadOpsArr.length; i++) {
	autoLoaders.push(new AutoLoadPages(autoLoadOpsArr[i]));
}


// TEAM SLIDER
// BACKLOG: The resize code doesn't work b/c the number of slides isn't intended to change in CarouselAbstr.ts,
// and on tablets and phones, it prevents the carousel from working properly altogether
const rewrapSlides = function($slides: JQuery<HTMLElement>, slideClass: string, groupSize: number): void {
	$slides.filter(':not(.' + slideClass + ')').unwrap();
	$slides.removeClass(slideClass);
	
	let i = 0;
	for (; i < $slides.length - groupSize; i += groupSize) {
		const $slice = $slides.slice(i, i + groupSize);
		if (i == 0) {
			$slice.wrapAll('<div class="' + slideClass + ' active"></div>');
		} else {
			$slice.wrapAll('<div class="' + slideClass + '"></div>');
		}
	}
	
	if (i != $slides.length) {
		if (i == 0) {
			$slides.slice(i).wrapAll('<div class="' + slideClass + ' active"></div>');
		} else {
			$slides.slice(i).wrapAll('<div class="' + slideClass + '"></div>');
		}
	}
}

// const teamSliderResizeDebouncer = new Debouncer(function(): void {
	if (ViewportTracker.below('teamMember_2col', true)) {
		const $teamMembers = $('.teamCarousel__frameWrap .teamMember:not(.teamCarousel__slide)');
		if ($teamMembers.length > 0) {
			/* $teamMembers.unwrap();
			$teamMembers.slice(0, 1).addClass('teamCarousel__slide active');
			$teamMembers.slice(1).addClass('teamCarousel__slide'); */
			rewrapSlides($('.teamCarousel__frameWrap .teamMember'), 'teamCarousel__slide', 1);
		}
	} else if (ViewportTracker.between({minName: 'teamMember_2col', maxName: 'teamMember_3col'}, {minInclusive: false, maxInclusive: true})) {
		rewrapSlides($('.teamCarousel__frameWrap .teamMember'), 'teamCarousel__slide', 2);
	} else if (ViewportTracker.above('teamMember_3col', true)) {
		rewrapSlides($('.teamCarousel__frameWrap .teamMember'), 'teamCarousel__slide', 3);
	}
// });

// teamSliderResizeDebouncer.runNow();
// window.addEventListener('resize', teamSliderResizeDebouncer.run);

import Team from './component/Team';
const teamEl = document.getElementsByClassName('teamCarousel__frameWrap');
for (let i = 0; i < teamEl.length; i++) {
	new Team({
		carouselEl: teamEl[i] as HTMLElement,
		carouselClass: 'teamCarousel'
	});
}
